import 'babel-polyfill';
import round10 from 'round10';

import _ from 'lodash';
import Backbone from 'backbone';

import '../../core/styles/fonts.styl';
import '../../core/styles/application.styl';
import './styles/preload.styl';
import './styles/coming-soon.styl';
import './styles/style.styl';
import '../../core/extends';

import { LodashMixines, fbInit, Secret } from '../../core/utils';

import App from './App';

round10.polyfill();
fbInit();
_.mixin(LodashMixines);

document.addEventListener('DOMContentLoaded', () => {
	const app = new App();

	new Secret(JSON.parse(process.env.IS_PRE_SEASON));

	app.start();

	Backbone.history.start({
		pushState: true,
		root: '/'
	});

	$(document).on('click', 'a[href^="/"]:not([href^="//"], [target^="_blank"])',  e => {
		e.preventDefault();

		const href = $(e.currentTarget).attr('href');

		Backbone.history.navigate(href, { trigger: true });
	});
});